<template>
  <div class="createAn4-box">
    <div class="laber-box intro-x">
      <div class="left">
        <img src="../assets/images/zhiyinText.png" alt="" />
      </div>

      <div class="right">
        授信模式仅需支付1000元启动资金即可享受付费版所有功能，支付并完成认证后<br />系统会评估您的信用分，为您分配信用额度，可以享受先用后付权利
      </div>
    </div>

    <div class="table-box intro-x">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="功能模块" show-overflow-tooltip>
          <!-- eslint-disable-next-line -->
          <template slot-scope="scope">
            <div class="scopeTitle">{{ scope.row.title }}</div>
          </template>
        </el-table-column>
        <el-table-column
          align="right"
          label="选购终端"
          width="250"
          show-overflow-tooltip
        >
          <!-- eslint-disable-next-line -->
          <template slot-scope="scope">
            <span>{{ scope.row.formName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="right"
          label="有效期"
          width="100"
          show-overflow-tooltip
        >
          <!-- eslint-disable-next-line -->
          <template slot-scope="scope">
            <span
              class="scopeDiscounts"
              :style="scope.row.discounts == '无' ? 'color:#788598' : ''"
              >{{ scope.row.period }}</span
            >
          </template>
        </el-table-column>
        <el-table-column align="right" prop="money" label="金额" width="120">
        </el-table-column>
      </el-table>
    </div>

    <div class="table-box-2 intro-x">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="订单详情" show-overflow-tooltip  min-width="60">
          <template slot-scope="scope">
            <div class="scopeTitle">{{ scope.row.title }}</div>
            <div class="scopeformName">{{ scope.row.formName }}</div>
          </template>
        </el-table-column>

        <el-table-column align="right" min-width="40" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="money-color">￥{{ scope.row.money }}</div>
            <div>有效期：一年</div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="aggregate-box">
      <div style="float: left">
        <div
          class="fukuai-box"
          :class="{ payClass: pay_way == '1' }"
          @click="getPay_way('1')"
        >
          <img src="../assets/images/zhifubao.png" alt="" />
          <span>支付宝支付</span>
          <i :class="pay_way == '1' ? 'el-icon-success' : 'icon-error'"></i>
        </div>
        <div
          class="fukuai-box"
          :class="{ payClass: pay_way == '0' }"
          @click="getPay_way('0')"
        >
          <img src="../assets/images/qianbao.png" alt="" />
          <span>余额支付</span>
          <i :class="pay_way == '0' ? 'el-icon-success' : 'icon-error'"></i>
        </div>
      </div>

      <div style="float: right; text-align: right">
        <div style="color: #728196; font-size: 16px">总计金额</div>
        <div style="color: #1890ff; font-size: 20px; margin: 2px 0">
          {{ calcData.price | formatMoney }}
        </div>
        <div style="color: #394251; font-size: 14px">
          共省 ¥ {{ saveMoney }}
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import request from "../utils/request";

export default {
  props: ["mergeArr", "calcData", "createAn4Param"],
  data() {
    return {
      pay_way: "1",
      saveMoney: 0,
      calcData2: null,
    };
  },
  computed: {
    tableData: function () {
      return this.mergeArr;
    },
  },
  mounted() {
    this.getPay_way("1");
  },

  methods: {
    getPay_way: function (value) {
      let param = this.createAn4Param;

      this.pay_way = value;
      param.pay_way = value;
      request({
        url: "/api/plan/calc",
        method: "POST",
        data: param,
      })
        .then((res) => {
          this.calcData2 = res.data;
        })
        .catch((err) => {});
    },
  },

  activated() {},
};
</script>

<style lang="scss" scoped>
.aggregate-box {
  width: 100%;
  margin-top: 20px;
  overflow: hidden;
  .payClass {
    border: 1px solid #1890ff !important;
  }
  .fukuai-box {
    display: inline-block;
    padding: 15px 20px;
    width: 250px;
    height: 78px;
    background: #ffffff;
    border: 1px solid #eef2f7;

    opacity: 1;
    border-radius: 22px;
    box-sizing: border-box;
    margin-right: 20px;
    img {
      height: 48px;
      display: inline-block;
      margin-right: 20px;
    }
    .el-icon-success {
      float: right;
      font-size: 20px;
      margin-top: 15px;
      color: #1890ff;
    }
    .icon-error {
      float: right;
      margin-top: 15px;
      width: 20px;
      height: 20px;

      border: 1px solid #e6e8ee;
      border-radius: 50%;
    }
  }
}

.createAn4-box {
  margin-top: 30px;
  padding: 0 116px;
  overflow: hidden;
  box-sizing: border-box;
  .laber-box {
    width: 100%;
    overflow: hidden;
    margin-bottom: 30px;
    .left {
      float: left;
      height: 48px;
      img {
        height: 48px;
      }
    }
    .right {
      float: left;
      font-size: 14px;
      color: #999999;
      margin-top: 6px;
      margin-left: 18px;
    }
  }
  .itemLeftImg {
    float: left;
    overflow: hidden;
    width: 48px;
    line-height: 6.7;

    img {
      width: 48px;
      height: 48px;
      vertical-align: middle;
      display: inline-block;
    }
  }

  .laberContent {
    display: inline-block;
    .item1 {
      color: #333333;
      font-size: 14px;
      text-align: center;
    }
    .item2 {
      font-size: 12px;
      color: #999999;
      padding-left: 58px;
    }
  }
  .float-yuan {
    width: 20px;
    height: 20px;
    background: #1890ff;
    border-radius: 50%;
    position: absolute;
    right: 20px;
    bottom: 10px;
    text-align: center;
    line-height: 20px;
    color: #ffffff;
    font-weight: bold;
    box-shadow: #e2e2e2 0px 0px 2px;
  }
  .isLaberTrue {
    border-color: #1890ff !important;
  }
}

.scopeTitle {
  color: #333;
  font-size: 14px;
}

.scopeCotnent {
  color: #999999 !important;
  font-size: 12px !important;
}

.scopeDiscounts {
  color: #ff4242;
}
.promotionCode-box {
  overflow: hidden;
  margin-top: 13px;

  .promotionCode {
    float: left;
    span {
      display: inline-block;
      height: 40px;
      line-height: 40px;
      margin-right: 10px;
      color: #333333;
      font-size: 14px;
    }
    .el-Input {
      display: inline-block;
      height: 40px;
      width: 465px;
    }
  }
  .promotionMoney {
    float: right;
    height: 40px;
    line-height: 40px;
    color: #ff4242;
    font-size: 14px;
  }
}

.totalMoney-box {
  overflow: hidden;
  .totalMoney-right {
    float: right;
    text-align: right;
    .div1 {
      font-size: 16px;
      color: #728196;
    }
    .div2 {
      color: #1890ff;
      font-weight: bold;
      font-size: 20px;
      margin: 4px 0;
    }
    .div3 {
      font-size: 14px;
      color: #394251;
    }
  }
}

.scopeMoney1 {
  color: #999999;
  font-size: 14px;
  text-decoration: line-through;
  margin-right: 5px;
}

.scopeMoney1::before {
  content: "¥";
}

.table-box-2 {
  display: none;
}

@media screen and (max-width:600px) {
  .scopeTitle {
      overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  }
  .scopeformName {
  color: #999999;
  font-size: 12px;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}

  .table-box-2 {
    display: block;
  }
  .Code-title {
    color: #333333 !important;
    font-size: 15px !important;
    padding-left: 6px !important;
    border-left: #1890ff 4px solid !important;
    height: 20px !important;
    line-height: 20px !important;
    margin-bottom: 10px;
    font-weight: bold;
  }

  .table-box {
    display: none !important;
  }

  .createAn4-box {
    padding: 0 4vw !important;
    .laber-box {
      justify-content: space-between;
      flex-direction: row;
      flex-wrap: wrap;
    }
  }

  .totalMoney-box {
    margin-top: 1rem !important;
  }

  .laberItem-box {
    width: 100% !important;
    margin-right: 0 !important;
    padding-left: 20px !important;
  }
  .el-Input {
    width: 100% !important;
  }

  .fukuai-box {
    width: 100% !important;
    margin-right: 0 !important;
    margin-bottom: 10px;
  }

  .money-color {
    color: #1890FF;
    font-size: 13px;
  }
}
</style>
